import { blogContent } from './blogContent.js';
import { blogImages } from './blogImages.js';

const blogPostsSeed = [
  {
    slug: "mi-primer-cuento-infantil",
    title: "Mi primer cuento infantil",
    excerpt: "“No quiero dormir”: así se llama mi primer cuento Hoy quiero compartirte algo muy especial: hace unas semanas presenté mi cuento en la Feria Internacional",
    date: "2025-05-27",
    displayDate: "27 mayo, 2025",
    image: "https://lucilapistiner.com/wp-content/uploads/2025/05/IMG_1090-1-768x1024.jpg",
    originalUrl: "https://lucilapistiner.com/mi-primer-cuento-infantil/",
    contentHtml: blogContent["mi-primer-cuento-infantil"],
  },
  {
    slug: "despertar-a-tu-bebe-de-la-siesta-deberias-hacerlo-o-no",
    title: "Despertar a tu bebé de la siesta, ¿deberías hacerlo o no?",
    excerpt: "El sueño de los bebés suele ser un tema que genera muchas dudas entre madres, padres y cuidadores. Una de las preguntas más frecuentes es:",
    date: "2024-12-26",
    displayDate: "26 diciembre, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/11/portada-4-diciembre-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/despertar-a-tu-bebe-de-la-siesta-deberias-hacerlo-o-no/",
    contentHtml: blogContent["despertar-a-tu-bebe-de-la-siesta-deberias-hacerlo-o-no"],
  },
  {
    slug: "trabajar-hasta-tarde-como-manejar-el-sueno-del-bebe",
    title: "Trabajar hasta tarde: ¿Cómo manejar el sueño del bebé?",
    excerpt: "Para muchas familias, el desafío de equilibrar horarios de trabajar y la rutina de sueño del bebé puede generar culpa, dudas e incluso frustración. ¿Qué",
    date: "2024-12-19",
    displayDate: "19 diciembre, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/11/portada-3-diciembre-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/trabajar-hasta-tarde-como-manejar-el-sueno-del-bebe/",
    contentHtml: blogContent["trabajar-hasta-tarde-como-manejar-el-sueno-del-bebe"],
  },
  {
    slug: "rutina-flexible-vs-cronograma-de-horarios-que-es-mejor",
    title: "Rutina flexible vs. cronograma de horarios, ¿qué es mejor?",
    excerpt: "El sueño de los bebés puede ser un desafío, especialmente en los primeros meses, cuando todo parece desorganizado. Entre tantos consejos y recomendaciones, surge una",
    date: "2024-12-12",
    displayDate: "12 diciembre, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/11/portada-2-diciembre-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/rutina-flexible-vs-cronograma-de-horarios-que-es-mejor/",
    contentHtml: blogContent["rutina-flexible-vs-cronograma-de-horarios-que-es-mejor"],
  },
  {
    slug: "primeros-meses-todo-lo-que-necesitas-saber-sobre-las-siestas",
    title: "Primeros meses: todo lo que necesitás saber sobre las siestas",
    excerpt: "Si sos mamá de un bebé menor de 6 meses, seguramente te habrás preguntado si las siestas de tu pequeño son demasiado cortas o si",
    date: "2024-12-05",
    displayDate: "5 diciembre, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/11/portada-1-diciembre-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/primeros-meses-todo-lo-que-necesitas-saber-sobre-las-siestas/",
    contentHtml: blogContent["primeros-meses-todo-lo-que-necesitas-saber-sobre-las-siestas"],
  },
  {
    slug: "mal-descanso-los-efectos-en-bebes-y-ninos",
    title: "Mal descanso: Los efectos en bebés y niños",
    excerpt: "El sueño es esencial para el desarrollo físico, emocional y mental de los bebés y niños. Sin embargo, cuando no duermen bien, los efectos negativos",
    date: "2024-11-28",
    displayDate: "28 noviembre, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/11/portada-4-noviembre-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/mal-descanso-los-efectos-en-bebes-y-ninos/",
    contentHtml: blogContent["mal-descanso-los-efectos-en-bebes-y-ninos"],
  },
  {
    slug: "senales-de-sueno-claves-para-identificarlas-a-tiempo",
    title: "Señales de sueño: Claves para identificarlas a tiempo",
    excerpt: "Muchas mamás enfrentan un desafío común: lograr que sus bebés duerman siestas de manera tranquila y efectiva. La situación suele ser frustrante, especialmente cuando los",
    date: "2024-11-21",
    displayDate: "21 noviembre, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/11/portada-3-noviembre-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/senales-de-sueno-claves-para-identificarlas-a-tiempo/",
    contentHtml: blogContent["senales-de-sueno-claves-para-identificarlas-a-tiempo"],
  },
  {
    slug: "alargar-las-siestas-3-consejos",
    title: "Alargar las siestas: 3 consejos",
    excerpt: "Las siestas cortas pueden ser un desafío frustrante para muchas familias, especialmente cuando tu bebé se despierta a los 30 o 40 minutos de haber",
    date: "2024-11-14",
    displayDate: "14 noviembre, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/11/portada-2-noviembre-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/alargar-las-siestas-3-consejos/",
    contentHtml: blogContent["alargar-las-siestas-3-consejos"],
  },
  {
    slug: "levantarse-temprano-5-causas",
    title: "Levantarse temprano: 5 causas",
    excerpt: "¿Te preguntaste alguna vez por qué tu hijo/a tiende a levantarse temprano a la mañana, incluso antes de las 6 a.m.? Si las madrugadas se",
    date: "2024-11-07",
    displayDate: "7 noviembre, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/11/portada-1-noviembre-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/levantarse-temprano-5-causas/",
    contentHtml: blogContent["levantarse-temprano-5-causas"],
  },
  {
    slug: "papilla-como-alimentacion-complementaria",
    title: "Papilla como alimentación complementaria",
    excerpt: "La papilla ha sido un pilar en la alimentación complementaria durante generaciones. Sin embargo, es importante entender cómo y cuándo utilizarla para asegurar un desarrollo",
    date: "2024-10-23",
    displayDate: "23 octubre, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/09/portada-4-octubre-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/papilla-como-alimentacion-complementaria/",
    contentHtml: blogContent["papilla-como-alimentacion-complementaria"],
  },
  {
    slug: "habitos-como-modificarlos-en-tu-hijo",
    title: "Hábitos: cómo modificarlos en tu hijo",
    excerpt: "Existen situaciones que suelen ser comunes y la respuesta para solucionarlas puede estar en los hábitos: ¿Cuántas veces te ha pasado levantarte en medio de",
    date: "2024-10-16",
    displayDate: "16 octubre, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/09/portada-3-octubre-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/habitos-como-modificarlos-en-tu-hijo/",
    contentHtml: blogContent["habitos-como-modificarlos-en-tu-hijo"],
  },
  {
    slug: "siesta-fuera-de-casa-como-hacer-que-sean-mas-tranquilas",
    title: "Siesta fuera de casa: Cómo hacer que sea más tranquila",
    excerpt: "Las siestas de los bebés son esenciales para su descanso y desarrollo, pero mantener sus rutinas enfrentarnos a la siesta fuera de casa puede ser",
    date: "2024-10-09",
    displayDate: "9 octubre, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/09/portada-2-octubre-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/siesta-fuera-de-casa-como-hacer-que-sean-mas-tranquilas/",
    contentHtml: blogContent["siesta-fuera-de-casa-como-hacer-que-sean-mas-tranquilas"],
  },
  {
    slug: "beneficios-del-blw-autonomia-y-alimentacion-saludable",
    title: "Beneficios del BLW: Autonomía y alimentación saludable",
    excerpt: "El método Baby-Led Weaning (BLW) se ha convertido en una opción popular para la alimentación complementaria, ya que ofrece múltiples beneficios tanto para el bebé",
    date: "2024-10-02",
    displayDate: "2 octubre, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/09/portada-1-octubre-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/beneficios-del-blw-autonomia-y-alimentacion-saludable/",
    contentHtml: blogContent["beneficios-del-blw-autonomia-y-alimentacion-saludable"],
  },
  {
    slug: "temores-reales-durante-el-proceso-de-control-de-esfinteres",
    title: "Temores reales durante el proceso de control de esfínteres",
    excerpt: "El proceso de control de esfínteres no solo implica un cambio físico, sino también un desafío emocional para muchos/as niños/as. Algunos temores surgen de situaciones",
    date: "2024-09-26",
    displayDate: "26 septiembre, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/09/portada-4-septiembre-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/temores-reales-durante-el-proceso-de-control-de-esfinteres/",
    contentHtml: blogContent["temores-reales-durante-el-proceso-de-control-de-esfinteres"],
  },
  {
    slug: "llanto-al-pasarlo-a-la-habitacion-consejos-para-manejarlo",
    title: "Llanto al pasarlo a la habitación: consejos para manejarlo",
    excerpt: "Es común que los niños se resistan a la hora de dormir y recurran al llanto para manifestarlo, especialmente cuando el mundo a su alrededor",
    date: "2024-09-19",
    displayDate: "19 septiembre, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/09/portada-3-septiembre-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/llanto-al-pasarlo-a-la-habitacion-consejos-para-manejarlo/",
    contentHtml: blogContent["llanto-al-pasarlo-a-la-habitacion-consejos-para-manejarlo"],
  },
  {
    slug: "autonomia-pasos-en-el-metodo-blw",
    title: "Autonomía: pasos en el método BLW",
    excerpt: "El método Baby-Led Weaning (BLW) es una forma de alimentación complementaria que fomenta la autonomía del bebé al permitirle explorar y disfrutar de la comida",
    date: "2024-09-12",
    displayDate: "12 septiembre, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/09/portada-2-septiembre-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/autonomia-pasos-en-el-metodo-blw/",
    contentHtml: blogContent["autonomia-pasos-en-el-metodo-blw"],
  },
  {
    slug: "ansiedad-y-miedo-durante-el-proceso-de-control-de-esfinteres",
    title: "Ansiedad y miedo durante el proceso de control de esfínteres",
    excerpt: "Sabemos que el proceso de control de esfínteres es un hito en el desarrollo de un niño, pero también puede estar acompañado de miedo y",
    date: "2024-09-05",
    displayDate: "5 septiembre, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/09/portada-1-septiembre-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/ansiedad-y-miedo-durante-el-proceso-de-control-de-esfinteres/",
    contentHtml: blogContent["ansiedad-y-miedo-durante-el-proceso-de-control-de-esfinteres"],
  },
  {
    slug: "la-angustia-de-los-8-meses",
    title: "La angustia de los 8 meses",
    excerpt: "Es normal preocuparse cuando un bebé, que solía ser sociable y cómodo con extraños, de repente muestra descontento cuando sus figuras de referencia (mamá/papá) no",
    date: "2024-08-25",
    displayDate: "25 agosto, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/08/portada-4-agosto-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/la-angustia-de-los-8-meses/",
    contentHtml: blogContent["la-angustia-de-los-8-meses"],
  },
  {
    slug: "senales-de-sueno-la-clave-para-lograr-buenas-siestas",
    title: "Señales de sueño: la clave para lograr buenas siestas",
    excerpt: "Muchas mamás me comparten la dificultad que enfrentan para que sus bebés duerman siestas. A menudo, describen una situación en la que sus pequeños/as se",
    date: "2024-08-17",
    displayDate: "17 agosto, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/08/portada-3-agosto-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/senales-de-sueno-la-clave-para-lograr-buenas-siestas/",
    contentHtml: blogContent["senales-de-sueno-la-clave-para-lograr-buenas-siestas"],
  },
  {
    slug: "despertar-temprano-5-causas",
    title: "Despertar temprano: 5 causas por las que puede estar sucediendo",
    excerpt: "Si tu hijo/a está teniendo un despertar muy temprano por la mañana, antes de las 6 a.m., es importante revisar si alguna de las siguientes",
    date: "2024-08-09",
    displayDate: "9 agosto, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/08/portada-2-agosto-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/despertar-temprano-5-causas/",
    contentHtml: blogContent["despertar-temprano-5-causas"],
  },
  {
    slug: "frustracion-como-acompanar-en-esos-momentos",
    title: "Frustración: cómo acompañar en esos momentos",
    excerpt: "Criar a nuestros hijos es todo un desafío, especialmente cuando enfrentan momentos de frustración. Por eso, acá te dejamos algunos consejos sobre lo que deberías",
    date: "2024-08-03",
    displayDate: "3 agosto, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/08/portada-1-agosto-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/frustracion-como-acompanar-en-esos-momentos/",
    contentHtml: blogContent["frustracion-como-acompanar-en-esos-momentos"],
  },
  {
    slug: "estrategias-para-siestas-en-bebes-menores-de-6-meses",
    title: "Estrategias para siestas en bebés menores de 6 meses",
    excerpt: "Una de las preocupaciones más comunes entre las mamás de bebés menores de 6 meses es la duración y la calidad de las siestas de",
    date: "2024-07-26",
    displayDate: "26 julio, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/07/portada-4-julio-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/estrategias-para-siestas-en-bebes-menores-de-6-meses/",
    contentHtml: blogContent["estrategias-para-siestas-en-bebes-menores-de-6-meses"],
  },
  {
    slug: "ventanas-de-sueno-sirven-o-no",
    title: "Ventanas de sueño: ¿sirven o no?",
    excerpt: "¿Qué son las ventanas de sueño? Las ventanas de sueño son aquellos períodos de tiempo durante los cuales bebés y niños/as deberían estar despiertos/as. Estas",
    date: "2024-07-19",
    displayDate: "19 julio, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/07/12-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/ventanas-de-sueno-sirven-o-no/",
    contentHtml: blogContent["ventanas-de-sueno-sirven-o-no"],
  },
  {
    slug: "octavo-mes-regresion-de-sueno",
    title: "Octavo mes: regresión de sueño",
    excerpt: "¿Qué es la regresión de sueño del octavo mes? A diferencia de la “regresión del cuarto mes”, es una fase temporal que dura unas semanas.",
    date: "2024-07-12",
    displayDate: "12 julio, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/07/13-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/octavo-mes-regresion-de-sueno/",
    contentHtml: blogContent["octavo-mes-regresion-de-sueno"],
  },
  {
    slug: "frustraciones-infantiles-estrategias-para-manejarlas",
    title: "Frustraciones infantiles: estrategias para manejarlas",
    excerpt: "Como madres y padres, uno de los mayores desafíos es sentirnos impotentes cuando nuestros/as hijos/as tienen frustraciones y no pueden calmarse. Tenemos que reconocer que",
    date: "2024-07-06",
    displayDate: "6 julio, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/07/14-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/frustraciones-infantiles-estrategias-para-manejarlas/",
    contentHtml: blogContent["frustraciones-infantiles-estrategias-para-manejarlas"],
  },
  {
    slug: "acompanar-el-control-de-esfinteres-4-claves",
    title: "Acompañar el control de esfínteres: 4 claves",
    excerpt: "El control de esfínteres es una etapa importante en el desarrollo de nuestros hijos, y como cuidadores, tenemos un papel igual de importante que ellos",
    date: "2024-06-28",
    displayDate: "28 junio, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/06/31-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/acompanar-el-control-de-esfinteres-4-claves/",
    contentHtml: blogContent["acompanar-el-control-de-esfinteres-4-claves"],
  },
  {
    slug: "siesta-larga-es-posible",
    title: "Siesta larga, ¿es posible?",
    excerpt: "Imagino la cantidad de veces que planificaste hacer todas esas cosas mientras tu bebé duerme siesta, pero finalmente lográs un cuarto de todo eso, porque",
    date: "2024-06-20",
    displayDate: "20 junio, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/06/16-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/siesta-larga-es-posible/",
    contentHtml: blogContent["siesta-larga-es-posible"],
  },
  {
    slug: "bliss-y-blw-hay-diferencias",
    title: "BLISS Y BLW: ¿hay diferencias?",
    excerpt: "La transición a la alimentación sólida es un antes y un después en la vida de un bebé (y de la familia en general). Existen",
    date: "2024-06-14",
    displayDate: "14 junio, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/06/17-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/bliss-y-blw-hay-diferencias/",
    contentHtml: blogContent["bliss-y-blw-hay-diferencias"],
  },
  {
    slug: "los-3-tipos-de-desarrollo-para-el-control-de-esfinteres",
    title: "Desarrollo durante el control de esfínteres: 3 tipos",
    excerpt: "El control de esfínteres es un proceso en el desarrollo infantil que implica madurez motora, neurológica y emocional. Este hito no solo marca un avance",
    date: "2024-06-08",
    displayDate: "8 junio, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/06/18-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/los-3-tipos-de-desarrollo-para-el-control-de-esfinteres/",
    contentHtml: blogContent["los-3-tipos-de-desarrollo-para-el-control-de-esfinteres"],
  },
  {
    slug: "lenguaje-e-intencion-comunicativa",
    title: "Lenguaje e intención comunicativa",
    excerpt: "El lenguaje en su sentido amplio abarca tanto la comunicación verbal como la no verbal. No se trata solo del habla humana, sino de comprender",
    date: "2024-05-24",
    displayDate: "24 mayo, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/05/19-768x480.png",
    originalUrl: "https://lucilapistiner.com/lenguaje-e-intencion-comunicativa/",
    contentHtml: blogContent["lenguaje-e-intencion-comunicativa"],
  },
  {
    slug: "salud-mental-materna-consejos-para-cuidarla",
    title: "Salud mental materna: consejos para cuidarla",
    excerpt: "Se estima que 1 de cada 5 mujeres puede sufrir un problema de salud mental durante el embarazo o el puerperio. Algunas también presentan síntomas",
    date: "2024-05-15",
    displayDate: "15 mayo, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/05/20-768x480.png",
    originalUrl: "https://lucilapistiner.com/salud-mental-materna-consejos-para-cuidarla/",
    contentHtml: blogContent["salud-mental-materna-consejos-para-cuidarla"],
  },
  {
    slug: "terrores-nocturnos-vs-pesadillas-diferencias",
    title: "Terrores nocturnos vs. pesadillas, diferencias",
    excerpt: "En las noches de nuestros hijos, es común encontrarse con situaciones como las pesadillas y los terrores nocturnos, pero identificar y entender la diferencia entre",
    date: "2024-05-08",
    displayDate: "8 mayo, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/05/21-768x480.png",
    originalUrl: "https://lucilapistiner.com/terrores-nocturnos-vs-pesadillas-diferencias/",
    contentHtml: blogContent["terrores-nocturnos-vs-pesadillas-diferencias"],
  },
  {
    slug: "progresion-de-sueno-entre-los-4-y-20-meses-que-esperar",
    title: "Progresión de sueño entre los 4 y 20 meses: qué esperar",
    excerpt: "Durante los primeros 20 meses de vida de un bebé, el sueño experimenta una evolución significativa marcada por hitos de desarrollo y cambios en las",
    date: "2024-05-03",
    displayDate: "3 mayo, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/05/22-768x480.png",
    originalUrl: "https://lucilapistiner.com/progresion-de-sueno-entre-los-4-y-20-meses-que-esperar/",
    contentHtml: blogContent["progresion-de-sueno-entre-los-4-y-20-meses-que-esperar"],
  },
  {
    slug: "el-reloj-biologico-el-papel-de-las-hormonas-en-el-sueno",
    title: "El reloj biológico: el papel de las hormonas en el sueño",
    excerpt: "El sueño de los/as niños/as está estrechamente ligado a su reloj biológico, un mecanismo interno que regula los ciclos de sueño y vigilia en respuesta",
    date: "2024-04-28",
    displayDate: "28 abril, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/04/35-768x480.png",
    originalUrl: "https://lucilapistiner.com/el-reloj-biologico-el-papel-de-las-hormonas-en-el-sueno/",
    contentHtml: blogContent["el-reloj-biologico-el-papel-de-las-hormonas-en-el-sueno"],
  },
  {
    slug: "la-familia-por-que-es-importante-que-sea-equipo",
    title: "La familia, por qué es importante que sea equipo",
    excerpt: "En la crianza y manejo del sueño de niños/as, la colaboración y coordinación entre los adultos de la familia a cargo juegan un papel muy",
    date: "2024-04-26",
    displayDate: "26 abril, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/04/23-768x480.png",
    originalUrl: "https://lucilapistiner.com/la-familia-por-que-es-importante-que-sea-equipo/",
    contentHtml: blogContent["la-familia-por-que-es-importante-que-sea-equipo"],
  },
  {
    slug: "comunicacion-y-conducta-como-se-expresan-los-ninos",
    title: "Comunicación y conducta, cómo se expresan los niños",
    excerpt: "En la crianza de los niños, es clave entender la comunicación y la conducta, ya que la primera va más allá de las palabras y",
    date: "2024-04-19",
    displayDate: "19 abril, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/04/30-768x480.png",
    originalUrl: "https://lucilapistiner.com/comunicacion-y-conducta-como-se-expresan-los-ninos/",
    contentHtml: blogContent["comunicacion-y-conducta-como-se-expresan-los-ninos"],
  },
  {
    slug: "sueno-del-bebe-esperar-es-la-solucion",
    title: "Sueño del bebé: ¿Esperar es la solución?",
    excerpt: "Muchas veces leo comentarios de mamás muy cansadas debido al sueño del bebé que en general, reciben la respuesta más común que es “ hay",
    date: "2024-04-11",
    displayDate: "11 abril, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/04/29-768x480.png",
    originalUrl: "https://lucilapistiner.com/sueno-del-bebe-esperar-es-la-solucion/",
    contentHtml: blogContent["sueno-del-bebe-esperar-es-la-solucion"],
  },
  {
    slug: "control-de-esfinteres-fases",
    title: "Control de esfínteres: las fases por las que pasan los niños",
    excerpt: "El proceso de control de esfínteres es un camino largo en el desarrollo de los niños, y no sigue un patrón rígido, es decir, no",
    date: "2024-04-04",
    displayDate: "4 abril, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/04/28-768x480.png",
    originalUrl: "https://lucilapistiner.com/control-de-esfinteres-fases/",
    contentHtml: blogContent["control-de-esfinteres-fases"],
  },
  {
    slug: "cuarto-mes-cambios-en-el-sueno-y-consejos",
    title: "Cuarto mes: cambios en el sueño y consejos",
    excerpt: "El sueño de un bebé (lo sabemos muy bien acá) es un proceso complejo que va evolucionando con el tiempo, hoy vamos a hablar de",
    date: "2024-03-28",
    displayDate: "28 marzo, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/03/27-768x480.png",
    originalUrl: "https://lucilapistiner.com/cuarto-mes-cambios-en-el-sueno-y-consejos/",
    contentHtml: blogContent["cuarto-mes-cambios-en-el-sueno-y-consejos"],
  },
  {
    slug: "blw-como-saber-si-tu-bebe-esta-listo-para-esta-alimentacion",
    title: "BLW: cómo saber si tu bebé está listo para esta alimentación",
    excerpt: "La introducción de la BLW (Baby Led Weaning o alimentación autorregulada por el bebé) en la dieta de un bebé es un desafío para muchos",
    date: "2024-03-21",
    displayDate: "21 marzo, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/03/26-768x480.png",
    originalUrl: "https://lucilapistiner.com/blw-como-saber-si-tu-bebe-esta-listo-para-esta-alimentacion/",
    contentHtml: blogContent["blw-como-saber-si-tu-bebe-esta-listo-para-esta-alimentacion"],
  },
  {
    slug: "jardin-de-infantes-consejos-para-el-comienzo",
    title: "Jardín de infantes: consejos para el comienzo",
    excerpt: "El inicio en el jardín marca un hito importante en la vida de nuestros hijos y también en la nuestra. Por eso, este proceso puede",
    date: "2024-03-14",
    displayDate: "14 marzo, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/03/25-768x480.png",
    originalUrl: "https://lucilapistiner.com/jardin-de-infantes-consejos-para-el-comienzo/",
    contentHtml: blogContent["jardin-de-infantes-consejos-para-el-comienzo"],
  },
  {
    slug: "nuestra-actitud-la-importancia-en-el-sueno-de-nuestros-hijos",
    title: "Nuestra actitud, la importancia en el sueño de nuestros hijos",
    excerpt: "En el momento que decidimos mejorar el sueño de nuestros hijos, solemos enfocarnos en ciertos aspectos: horarios, rutinas, ambiente de sueño y hábitos…. Sin embargo,",
    date: "2024-03-07",
    displayDate: "7 marzo, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/03/24-768x480.png",
    originalUrl: "https://lucilapistiner.com/nuestra-actitud-la-importancia-en-el-sueno-de-nuestros-hijos/",
    contentHtml: blogContent["nuestra-actitud-la-importancia-en-el-sueno-de-nuestros-hijos"],
  },
  {
    slug: "opiniones-sobre-la-hora-de-dormir",
    title: "Opiniones sobre la hora de dormir",
    excerpt: "Siempre se habla mucho sobre las consecuencias de dormir tarde en los adultos, (deuda de sueño, somnolencia en el día, tendencia a la obesidad, menor",
    date: "2024-02-29",
    displayDate: "29 febrero, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/02/36-768x480.png",
    originalUrl: "https://lucilapistiner.com/opiniones-sobre-la-hora-de-dormir/",
    contentHtml: blogContent["opiniones-sobre-la-hora-de-dormir"],
  },
  {
    slug: "dormir-solos-consejos-practicos-para-la-transicion",
    title: "Dormir solos: consejos prácticos para la transición",
    excerpt: "Durante los primeros meses de vida los bebés nos necesitan al 100%, ya que son puras demandas y necesidades, y como madres/padres, estamos completamente inmersos",
    date: "2024-02-23",
    displayDate: "23 febrero, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/02/39-768x480.png",
    originalUrl: "https://lucilapistiner.com/dormir-solos-consejos-practicos-para-la-transicion/",
    contentHtml: blogContent["dormir-solos-consejos-practicos-para-la-transicion"],
  },
  {
    slug: "evitar-el-sobrecansancio-como-entender-y-respetar-el-sueno",
    title: "Evitar el sobrecansancio: cómo entender y respetar el sueño",
    excerpt: "Sabemos que en la crianza el sueño es uno de los aspectos más importantes en su desarrollo. Por eso, la importancia de las siestas no",
    date: "2024-02-16",
    displayDate: "16 febrero, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/02/38-768x480.png",
    originalUrl: "https://lucilapistiner.com/evitar-el-sobrecansancio-como-entender-y-respetar-el-sueno/",
    contentHtml: blogContent["evitar-el-sobrecansancio-como-entender-y-respetar-el-sueno"],
  },
  {
    slug: "segundo-hito-del-sueno-como-detectarlo-y-consejos",
    title: "Segundo hito del sueño, cómo detectarlo y consejos",
    excerpt: "Entre las 12 y 16 semanas de vida, nos encontramos en el segundo hito del sueño, un momento en el que hay que estar atentos/as",
    date: "2024-02-08",
    displayDate: "8 febrero, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/02/37-768x480.png",
    originalUrl: "https://lucilapistiner.com/segundo-hito-del-sueno-como-detectarlo-y-consejos/",
    contentHtml: blogContent["segundo-hito-del-sueno-como-detectarlo-y-consejos"],
  },
  {
    slug: "vacaciones-y-el-sueno-de-tu-bebe-consejos-para-disfrutarlas",
    title: "Vacaciones y el sueño de tu bebé, ¡consejos para disfrutarlas!",
    excerpt: "Sabemos que las vacaciones con nuestros/as hijos/as son hermosas, pero también pueden ser muy, muy agotadoras. Hasta suele pasar que en este tiempo de descanso,",
    date: "2024-01-25",
    displayDate: "25 enero, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/01/45-768x480.png",
    originalUrl: "https://lucilapistiner.com/vacaciones-y-el-sueno-de-tu-bebe-consejos-para-disfrutarlas/",
    contentHtml: blogContent["vacaciones-y-el-sueno-de-tu-bebe-consejos-para-disfrutarlas"],
  },
  {
    slug: "primer-hito-del-sueno-cual-es-y-consejos-practicos",
    title: "Primer hito del sueño, cuál es y consejos prácticos",
    excerpt: "Cuando tu bebé comienza a mostrar señales de cambios en su sueño, es el momento ideal para adaptarse y apoyar su desarrollo. Acá te contamos",
    date: "2024-01-19",
    displayDate: "19 enero, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/01/44-768x480.png",
    originalUrl: "https://lucilapistiner.com/primer-hito-del-sueno-cual-es-y-consejos-practicos/",
    contentHtml: blogContent["primer-hito-del-sueno-cual-es-y-consejos-practicos"],
  },
  {
    slug: "siestas-cuanto-deberian-durar",
    title: "Siestas, ¿cuánto deberían durar?",
    excerpt: "Esta es una de las preguntas que más recibo, así que vamos a responderla: ¿cuánto debería durar una siesta? Primero, empecemos con una aclaración. Va",
    date: "2024-01-10",
    displayDate: "10 enero, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/01/43-768x480.png",
    originalUrl: "https://lucilapistiner.com/siestas-cuanto-deberian-durar/",
    contentHtml: blogContent["siestas-cuanto-deberian-durar"],
  },
  {
    slug: "primeras-semanas-de-tu-bebe-consejos-que-te-van-a-servir",
    title: "Primeras semanas de tu bebé: consejos que te van a servir",
    excerpt: "Como dijimos en otro artículo, las primeras semanas de tu bebé son complicadas e implican un desafío para las madres y padres. Por eso, reunimos",
    date: "2024-01-05",
    displayDate: "5 enero, 2024",
    image: "https://lucilapistiner.com/wp-content/uploads/2024/01/42-768x480.png",
    originalUrl: "https://lucilapistiner.com/primeras-semanas-de-tu-bebe-consejos-que-te-van-a-servir/",
    contentHtml: blogContent["primeras-semanas-de-tu-bebe-consejos-que-te-van-a-servir"],
  },
  {
    slug: "primeras-semanas-que-tenes-que-saber-sobre-el-sueno-de-tu-bebe",
    title: "Primeras semanas: qué tenés que saber sobre el sueño de tu bebé",
    excerpt: "Las primeras semanas de vida (entre 6 y 8) de tu bebé son un período de adaptación tanto para él/ella como para las madres y",
    date: "2023-12-28",
    displayDate: "28 diciembre, 2023",
    image: "https://lucilapistiner.com/wp-content/uploads/2023/12/41-768x480.png",
    originalUrl: "https://lucilapistiner.com/primeras-semanas-que-tenes-que-saber-sobre-el-sueno-de-tu-bebe/",
    contentHtml: blogContent["primeras-semanas-que-tenes-que-saber-sobre-el-sueno-de-tu-bebe"],
  },
  {
    slug: "siesta-como-hacer-que-sea-beneficiosa-para-tu-bebe",
    title: "Siesta: cómo hacer que sea beneficiosa para tu bebé",
    excerpt: "Las siestas son una parte fundamental del desarrollo de los bebés, ya que contribuye muchísimo a su bienestar y crecimiento. Acá te contamos los principales",
    date: "2023-12-23",
    displayDate: "23 diciembre, 2023",
    image: "https://lucilapistiner.com/wp-content/uploads/2023/12/40-768x480.png",
    originalUrl: "https://lucilapistiner.com/siesta-como-hacer-que-sea-beneficiosa-para-tu-bebe/",
    contentHtml: blogContent["siesta-como-hacer-que-sea-beneficiosa-para-tu-bebe"],
  },
  {
    slug: "calidad-del-sueno-la-importancia-de-un-ambiente-oscuro",
    title: "Calidad del sueño: la importancia de un ambiente oscuro",
    excerpt: "El sueño de los bebés desempeña un papel crucial en su desarrollo físico y cognitivo, pero existe un aspecto que suele ser subestimado por las",
    date: "2023-12-14",
    displayDate: "14 diciembre, 2023",
    image: "https://lucilapistiner.com/wp-content/uploads/2023/12/333-768x480.png",
    originalUrl: "https://lucilapistiner.com/calidad-del-sueno-la-importancia-de-un-ambiente-oscuro/",
    contentHtml: blogContent["calidad-del-sueno-la-importancia-de-un-ambiente-oscuro"],
  },
  {
    slug: "porteo-y-cuna-como-encontrar-el-equilibrio",
    title: "Porteo y cuna: cómo encontrar el equilibrio",
    excerpt: "En muchas oportunidades, veo que los temas de crianza se separan en bandos opuestos, y el porteo parecería formar parte de uno de esos temas.",
    date: "2023-12-08",
    displayDate: "8 diciembre, 2023",
    image: "https://lucilapistiner.com/wp-content/uploads/2023/12/225-768x480.png",
    originalUrl: "https://lucilapistiner.com/porteo-y-cuna-como-encontrar-el-equilibrio/",
    contentHtml: blogContent["porteo-y-cuna-como-encontrar-el-equilibrio"],
  },
  {
    slug: "3-cambios-biologicos-de-tu-bebe-que-deberias-conocer",
    title: "3 cambios biológicos de tu bebé que deberías conocer",
    excerpt: "En los primeros meses, los bebés experimentan una serie de cambios biológicos en su patrón de sueño que son esenciales para comprender y ofrecer un",
    date: "2023-11-29",
    displayDate: "29 noviembre, 2023",
    image: "https://lucilapistiner.com/wp-content/uploads/2023/11/224-768x480.png",
    originalUrl: "https://lucilapistiner.com/3-cambios-biologicos-de-tu-bebe-que-deberias-conocer/",
    contentHtml: blogContent["3-cambios-biologicos-de-tu-bebe-que-deberias-conocer"],
  },
  {
    slug: "sueno-seguro-5-claves-para-lograrlo",
    title: "Sueño seguro en bebés: 5 claves para lograrlo",
    excerpt: "En los primeros meses de vida, sabemos que los bebés son vulnerables durante el sueño. Por eso, tomar medidas para que estén protegidos/as es esencial",
    date: "2023-11-21",
    displayDate: "21 noviembre, 2023",
    image: "https://lucilapistiner.com/wp-content/uploads/2023/11/223-768x480.png",
    originalUrl: "https://lucilapistiner.com/sueno-seguro-5-claves-para-lograrlo/",
    contentHtml: blogContent["sueno-seguro-5-claves-para-lograrlo"],
  },
  {
    slug: "mejorar-el-sueno-del-bebe",
    title: "Mejorar el sueño del bebé para no vivir cansados/as, ¡es posible!",
    excerpt: "Ya sabemos que la llegada de un bebé transforma por completo la dinámica familiar. Generalmente, se asocia con noches de no dormir y la idea",
    date: "2023-11-14",
    displayDate: "14 noviembre, 2023",
    image: "https://lucilapistiner.com/wp-content/uploads/2023/11/227-768x480.jpg",
    originalUrl: "https://lucilapistiner.com/mejorar-el-sueno-del-bebe/",
    contentHtml: blogContent["mejorar-el-sueno-del-bebe"],
  },
  {
    slug: "que-no-debemos-hacer-cuando-nuestro-hijo-a-tiene-una-pataleta",
    title: "Qué no debemos hacer cuando nuestro hijo/a tiene una pataleta",
    excerpt: "Hoy escribe Laura Francomano, Consultora de sueño infantil del equipo de Lu Pistiner, Lic. en Psicología, con Formación en Neurodesarrollo. Uno de los desafíos más",
    date: "2023-09-27",
    displayDate: "27 septiembre, 2023",
    image: "https://lucilapistiner.com/wp-content/uploads/2023/09/226-768x512.jpg",
    originalUrl: "https://lucilapistiner.com/que-no-debemos-hacer-cuando-nuestro-hijo-a-tiene-una-pataleta/",
    contentHtml: blogContent["que-no-debemos-hacer-cuando-nuestro-hijo-a-tiene-una-pataleta"],
  },
  {
    slug: "cuando-ocurren-las-transiciones-de-siestas",
    title: "¿Cuándo ocurren las transiciones de siestas?",
    excerpt: "A medida que los bebés crecen aumenta el tiempo que pueden pasar despiertos, y esto se traduce en abandonar siestas. A los 6 meses la",
    date: "2023-07-27",
    displayDate: "27 julio, 2023",
    image: "https://lucilapistiner.com/wp-content/uploads/2023/07/51-768x420.jpg",
    originalUrl: "https://lucilapistiner.com/cuando-ocurren-las-transiciones-de-siestas/",
    contentHtml: blogContent["cuando-ocurren-las-transiciones-de-siestas"],
  },
  {
    slug: "a-que-hora-deberia-terminar-la-ultima-siesta-del-dia",
    title: "¿A qué hora debería terminar la última siesta del día?",
    excerpt: "Son las 6pm…¿Qué hago, lo duermo ahora una siesta o espero, “se la estiro\\” y lo acuesto después para la noche? ¿Cuántas veces te preguntaste",
    date: "2023-07-06",
    displayDate: "6 julio, 2023",
    image: "https://lucilapistiner.com/wp-content/uploads/2023/07/48-768x432.jpg",
    originalUrl: "https://lucilapistiner.com/a-que-hora-deberia-terminar-la-ultima-siesta-del-dia/",
    contentHtml: blogContent["a-que-hora-deberia-terminar-la-ultima-siesta-del-dia"],
  },
  {
    slug: "las-razones-mas-comunes-por-las-que-tu-hijo-se-despierta",
    title: "Las razones más comunes por la que tu hijo se despierta",
    excerpt: "¿Cuántas veces te preguntaste por qué tu bebé se despierta de noche? Haces cálculos matemáticos, teorías, hipótesis varias… Déjame decirte que el sueño de los",
    date: "2023-06-30",
    displayDate: "30 junio, 2023",
    image: "https://lucilapistiner.com/wp-content/uploads/2023/06/50-768x512.jpg",
    originalUrl: "https://lucilapistiner.com/las-razones-mas-comunes-por-las-que-tu-hijo-se-despierta/",
    contentHtml: blogContent["las-razones-mas-comunes-por-las-que-tu-hijo-se-despierta"],
  },
  {
    slug: "regresion-12-meses",
    title: "Regresiones de sueño: 12 meses.",
    excerpt: "Ya sé que vas a pensar que esto nunca termina. En realidad lo que quiero explicarles es que las regresiones en el sueño tienen una",
    date: "2020-02-28",
    displayDate: "28 febrero, 2020",
    image: "https://lucilapistiner.com/wp-content/uploads/2020/02/49-768x1155.jpg",
    originalUrl: "https://lucilapistiner.com/regresion-12-meses/",
    contentHtml: blogContent["regresion-12-meses"],
  },
  {
    slug: "la-famosa-regresion-del-cuarto-mes",
    title: "La famosa “regresión del cuarto mes”",
    excerpt: "“Mi bebé de 4 meses se despierta más ahora que cuando era recién nacido”. Recibo estos mensajes diariamente. * En general entre los 3 y",
    date: "2020-02-28",
    displayDate: "28 febrero, 2020",
    image: "https://lucilapistiner.com/wp-content/uploads/2020/02/46-768x614.jpg",
    originalUrl: "https://lucilapistiner.com/la-famosa-regresion-del-cuarto-mes/",
    contentHtml: blogContent["la-famosa-regresion-del-cuarto-mes"],
  },
  {
    slug: "a-dormir-con-papa",
    title: "A dormir con papá",
    excerpt: "¿Quién duerme a tu bebé todas las noches? Muchas mamás me cuentan que les encantaría poder delegar de vez en cuando el momento de dormir",
    date: "2020-02-21",
    displayDate: "21 febrero, 2020",
    image: "https://lucilapistiner.com/wp-content/uploads/2020/02/47.jpg",
    originalUrl: "https://lucilapistiner.com/a-dormir-con-papa/",
    contentHtml: blogContent["a-dormir-con-papa"],
  },
  {
    slug: "siestas-recomendadas-por-edad",
    title: "Siestas recomendadas por edad.",
    excerpt: "Les dejo esta tabla como guía de siestas y horas de sueño recomendadas por edad. Recuerden que estos son promedios y no podemos generalizar las",
    date: "2020-02-17",
    displayDate: "17 febrero, 2020",
    image: "https://lucilapistiner.com/wp-content/uploads/2020/02/SIESTAS-1.png",
    originalUrl: "https://lucilapistiner.com/siestas-recomendadas-por-edad/",
    contentHtml: blogContent["siestas-recomendadas-por-edad"],
  },
  {
    slug: "porque-mi-bebe-hace-solo-siestas-cortas",
    title: "¿Porqué mi bebé hace solo siestas cortas?",
    excerpt: "Esta es una de las preocupaciones más frecuentes de las mamás de bebés menores de 6 meses.",
    date: "2019-04-01",
    displayDate: "1 abril, 2019",
    image: "https://lucilapistiner.com/wp-content/uploads/2019/04/03.jpg",
    originalUrl: "https://lucilapistiner.com/porque-mi-bebe-hace-solo-siestas-cortas/",
    contentHtml: blogContent["porque-mi-bebe-hace-solo-siestas-cortas"],
  },
  {
    slug: "importancia-de-subirse-a-la-ola-de-sueno",
    title: "Importancia de subirse a la “ola de sueño”",
    excerpt: "Muchas mamás me cuentan que les resulta muy difícil que sus bebés duerman siestas.",
    date: "2019-04-01",
    displayDate: "1 abril, 2019",
    image: "https://lucilapistiner.com/wp-content/uploads/2019/04/01.jpg",
    originalUrl: "https://lucilapistiner.com/importancia-de-subirse-a-la-ola-de-sueno/",
    contentHtml: blogContent["importancia-de-subirse-a-la-ola-de-sueno"],
  },
  {
    slug: "6-causas-por-las-que-tu-hijo-se-puede-estar-levantando-demasiado-temprano",
    title: "6 Causas por las que tu hijo se puede estar levantando demasiado temprano",
    excerpt: "Si tu hijo se está levantando por la mañana muy temprano la causa puede ser alguna de las siguientes.",
    date: "2019-04-01",
    displayDate: "1 abril, 2019",
    image: "https://lucilapistiner.com/wp-content/uploads/2019/04/02.jpg",
    originalUrl: "https://lucilapistiner.com/6-causas-por-las-que-tu-hijo-se-puede-estar-levantando-demasiado-temprano/",
    contentHtml: blogContent["6-causas-por-las-que-tu-hijo-se-puede-estar-levantando-demasiado-temprano"],
  }
];

export const blogPosts = blogPostsSeed.map((post) => ({
  ...post,
  image: blogImages[post.slug] ?? '/blog/parenting.jpg',
}));
